import script from "./CollectiveMembersDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectiveMembersDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CollectiveMembersDialog.vue?vue&type=style&index=0&id=4b205948&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b205948"]])

export default __exports__